// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"11e6d3d3711a8820feb8","888":"b033cd9ec90c166f1992"}[chunkId] + ".css";
};